// extracted by mini-css-extract-plugin
export default {"root":"FilesCounter__root--bW1N0"};